/* src/app/on-property/on-property.component.scss */
.on-property-container {
  width: 100%;
  height: 100%;
}
.on-property-container .on-property-header {
  width: 100%;
  height: 44px;
  background: #D9D9D9;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.2);
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.on-property-container .on-property-header .header-left {
  display: flex;
  align-items: center;
  margin-left: 16px;
}
.on-property-container .on-property-header .header-left .on-property-title {
  color: #000;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  margin-right: 15px;
}
.on-property-container .on-property-header .header-left .location-dropdown-container {
  height: 35px;
  width: 424px;
}
.on-property-container .on-property-header .header-left .location-dropdown-container .location-dropdown {
  background-color: white;
  width: 100%;
  height: 100%;
  text-align: start;
  text-overflow: ellipsis;
  white-space: pre;
  padding-right: 2.5rem;
  overflow: hidden;
}
.on-property-container .on-property-header .header-left .location-dropdown-container .location-dropdown:after {
  display: none;
}
.on-property-container .on-property-header .header-left .location-dropdown-container .dropdown-menu {
  padding: 0;
}
.on-property-container .on-property-header .header-left .location-dropdown-container .dropdown-menu .dropdown-list {
  list-style: none;
  padding-left: 0;
  margin-bottom: 0;
  max-height: 20rem;
  width: 520px;
  overflow-y: auto;
  overflow-x: hidden;
}
@media screen and (max-width: 767px) {
  .on-property-container .on-property-header .header-left .location-dropdown-container .dropdown-menu .dropdown-list {
    width: 360px;
  }
}
.on-property-container .on-property-header .header-left .location-dropdown-container .dropdown-menu .dropdown-list .dropdown-item {
  cursor: pointer;
  white-space: pre;
  overflow: hidden;
  text-overflow: ellipsis;
}
.on-property-container .on-property-header .header-left .location-dropdown-container .dropdown-menu .search-input-container {
  position: relative;
}
.on-property-container .on-property-header .header-left .location-dropdown-container .dropdown-menu .search-input-container .location-search-input {
  width: 100%;
  height: 32px;
  border-radius: 0;
  padding: 6px 16px;
}
.on-property-container .on-property-header .header-left .location-dropdown-container .dropdown-menu .search-input-container .location-search-input:focus {
  box-shadow: none;
  border-color: #979797;
}
.on-property-container .on-property-header .header-left .location-dropdown-container .dropdown-menu .search-input-container .btn {
  position: absolute;
  right: 0;
  top: 0;
  padding: 3px 12px;
}
.on-property-container .on-property-header .header-left .location-dropdown-container .dropdown-menu .search-input-container .search.icon:before {
  font-family: upsicons, fantasy !important;
  content: "\e668" !important;
  color: #000;
  font-size: 12px;
}
.on-property-container .on-property-header .header-left .location-dropdown-container .dropdown-menu .search-input-container .clear.icon:before {
  font-family: upsicons, fantasy !important;
  content: "\e67b" !important;
  color: #000;
  font-size: 12px;
}
.on-property-container .on-property-header .header-left .location-dropdown-container .ups-select-icon {
  position: relative;
}
.on-property-container .on-property-header .header-left .location-dropdown-container .ups-select-icon:after {
  font-family: upsicons, fantasy !important;
  content: "\e626" !important;
  color: #000;
  position: absolute;
  top: 0.15rem;
  right: 1rem;
  pointer-events: none;
}
.on-property-container .on-property-header .header-right {
  display: flex;
  align-items: center;
  margin-right: 8px;
}
.on-property-container .on-property-header .header-right .trailer-search-box {
  height: 38px;
  width: 350px;
  background: white;
}
.on-property-container .on-property-header .header-right .filter-button {
  box-shadow: none;
  background-color: white;
  top: 29px;
  border: thin #757575 solid;
  height: 100%;
  align-self: flex-end;
  margin-left: 12px;
}
.on-property-container .on-property-header .header-right .filter-button:before {
  font-family: upsicons, fantasy !important;
  content: "\e6cf" !important;
}
.on-property-container .on-property-body {
  height: calc(100vh - 154px);
  width: 100%;
  display: flex;
}
.on-property-container .on-property-body .on-property-map {
  height: 100%;
  width: calc(100vw - 360px);
}
.on-property-container .on-property-body .trailer-list-container {
  height: 100%;
  width: 360px;
  border-left: 1px solid #000;
}
.on-property-container .on-property-body .trailer-list-container .trailer-list-header {
  height: 32px;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
  display: flex;
  justify-content: space-between;
}
.on-property-container .on-property-body .trailer-list-container .trailer-list-header .trailer-list-header-label {
  color: #404040;
  font-size: 14px;
  font-style: italic;
  font-weight: 400;
  line-height: normal;
  padding: 8px 13px;
}
.on-property-container .on-property-body .trailer-list-container trailer-list {
  display: flex;
  height: calc(100vh - 246px);
}
.on-property-container .on-property-body .trailer-list-container .export-trailer-container {
  border-top: 1px solid #757575;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 60px;
}
.on-property-container .on-property-body .trailer-list-container .export-trailer-container button {
  color: #0662BB;
  border: 2px solid #0662BB;
  background-color: white;
  border-radius: 40px;
  height: 44px;
  width: 240px;
  font-size: 16px;
  font-weight: 500;
}
.search.icon:before {
  font-family: upsicons, fantasy !important;
  content: "\e668" !important;
  color: #FFF;
}
.clear.icon:before {
  font-family: upsicons, fantasy !important;
  content: "\e67b" !important;
  color: #FFF;
}
.bg-grey {
  background-color: #7F7A73;
}
.map {
  width: 100%;
  height: 100%;
}
.filter-sort-buttons .filter-button,
.filter-sort-buttons .ups-icon-sort {
  box-shadow: none;
  background-color: white;
  border: thin #0A8080 solid;
  height: 28px;
  width: 28px;
  align-self: flex-end;
  margin-right: 12px;
  color: #0A8080;
}
.filter-sort-buttons .filter-button.filter-active {
  background-color: #0A8080;
  color: white;
}
.filter-sort-buttons .filter-button:before,
.filter-sort-buttons .ups-icon-sort:before {
  font-family: upsicons, fantasy !important;
  height: 28px;
  display: flex;
  justify-content: center;
  position: relative;
  top: -3px;
}
.filter-sort-buttons .filter-button:before {
  content: "\e6cf" !important;
}
.filter,
.sort {
  position: absolute;
  z-index: 100;
  width: 240px;
  margin-left: 106px;
  top: 175px;
}
.form-bubble,
.sort-options {
  position: absolute;
  border: 1px solid #757575;
  padding: 19px;
  width: 100%;
  margin-bottom: 10px;
  margin-top: 15px;
  background-color: white;
}
.filter:before,
.sort:before {
  content: " ";
  position: absolute;
  width: 0;
  height: 0;
  left: calc(50% + 55px);
  top: -8px;
  border: 12px solid;
  border-color: transparent transparent #757575 transparent;
  pointer-events: none;
}
.sort:before {
  left: calc(50% + 95px);
}
.filter:after,
.sort:after {
  content: " ";
  position: absolute;
  width: 0;
  height: 0;
  left: calc(50% + 53px);
  top: -8px;
  border: 14px solid;
  border-color: transparent transparent #fff transparent;
  pointer-events: none;
}
.sort:after {
  left: calc(50% + 93px);
}
input[type=checkbox] {
  display: none;
}
.form-check {
  padding-left: 0.5em;
}
.form-check label {
  padding: 5px;
  margin-left: -10px;
  white-space: nowrap;
}
.form-check label:before {
  display: inline-block;
  content: "";
  width: 24px;
  height: 24px;
  color: black;
  border: 1px solid #979797;
  border-radius: 4px;
  cursor: pointer;
  vertical-align: middle;
}
input[type=checkbox]:checked + label:before {
  color: #00857D;
  content: "\e622" !important;
  font-size: 11px;
  font-family: upsicons, fantasy !important;
  background: #fff;
  text-align: center;
  line-height: 24px;
  font-weight: bolder;
}
.available-sort,
.empty-sort {
  margin-left: 12px;
  cursor: pointer;
  -webkit-user-select: none;
  user-select: none;
}
.ups-icon-arrowup,
.ups-icon-arrowdown {
  font-size: 10px;
  margin-left: -13.4px;
  vertical-align: middle;
}
/*# sourceMappingURL=on-property.component.css.map */
